import React from "react";
import { LevelSectionsUIProvider } from "./LevelSectionsUIContext";
import { LevelSectionsCard } from "./LevelSectionsCard";

export function LevelSectionsPage({ history }) {
  const levelSectionsUIEvents = {
    openNewLevelSectionPage: () => {
      history.push("/kur-siniflari/ekle");
    },
    openEditLevelSectionPage: (id) => {
      history.push(`/kur-siniflari/duzenle/${id}`);
    },
  };
  
  return (
    <LevelSectionsUIProvider levelSectionsUIEvents={levelSectionsUIEvents}>
      <LevelSectionsCard />
    </LevelSectionsUIProvider>
 );
}